/*
* Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
* SPDX-License-Identifier: MIT
*
* Licensed under the MIT License. See the LICENSE accompanying this file
* for the specific language governing permissions and limitations under
* the License.
*/

import React from 'react';
import { Hub } from '@aws-amplify/core';
import { AuthState, UI_AUTH_CHANNEL, TOAST_AUTH_ERROR_EVENT } from '@aws-amplify/ui-components';

import FormInlineError from '../FormInlineError/FormInlineError';
import { translateFormErrorMessage } from '../../utils/formErrorMessage';

const AUTH_FORM_STATES = [
	AuthState.SignIn,
	AuthState.SignUp,
	AuthState.ConfirmSignUp,
];

const LoginAuthError = ({ authState }) => {
	const [error, setError] = React.useState('');

	React.useEffect(() => {
		const handleToastErrors = ({ payload }) => {
			if (payload.event === TOAST_AUTH_ERROR_EVENT && payload.message) {
				setError(translateFormErrorMessage(payload.message));
			}
		};

		Hub.listen(UI_AUTH_CHANNEL, handleToastErrors);
		return () => Hub.remove(UI_AUTH_CHANNEL, handleToastErrors);
	}, []);

	React.useEffect(() => {
		if (!AUTH_FORM_STATES.includes(authState)) {
			setError('');
		}
	}, [authState]);

	return <FormInlineError message={error} />;
};

export default LoginAuthError;
